<div class="pam-backdrop">
  <div class="pam-card">
    <h2 class="pam-title">Restaurant Publication Agreement</h2>
    <div>
      <p>
        This Restaurant Partner Agreement (this &ldquo;Agreement&rdquo;) is entered into between
        Mammilway Inc., a Delaware corporation doing business as ForknFind (&ldquo;ForknFind,&rdquo;
        &ldquo;we,&rdquo; &ldquo;us&rdquo;), and the restaurant business identified below
        (&ldquo;Restaurant,&rdquo; &ldquo;you&rdquo;). By checking the box and clicking &ldquo;I
        Agree,&rdquo; you accept this Agreement and represent that you are authorized to bind the
        Restaurant.
      </p>
      <p class="pam-agreement-intro">
        Please review the full Restaurant Publication Agreement below before continuing.
      </p>
    </div>
    <div class="pam-body">
      <div class="pam-agreement">
        <!-- <p class="pam-agreement-intro">
          Please review the full Restaurant Publication Agreement below before continuing.
        </p> -->
        @for (section of agreementSections; track section.heading) {
          <h3 class="pam-section-heading">{{ section.heading }}</h3>
          @for (clause of section.clauses; track clause.text) {
            <p class="pam-clause">
              @if (clause.label) {
                <b>{{ clause.label }}</b>
              }
              {{ clause.text }}
            </p>
          }
        }
      </div>
    </div>
    <div>
      <p>
        By continuing, you agree to keep the information you provide accurate and complete, and
        understand that Fork &amp; Find may review your restaurant profile before full activation.
      </p>
    </div>
    <label class="pam-accept-row" [class.pam-accept-row--disabled]="loading">
      <input
        type="checkbox"
        [checked]="hasAcceptedTerms"
        [disabled]="loading"
        (change)="hasAcceptedTerms = !hasAcceptedTerms"
      />
      <b>I have read and agree to the Restaurant Publication Agreement above.</b>
    </label>
    <div class="pam-actions">
      <button
        type="button"
        class="btn btn-outline-dark rounded-3"
        [disabled]="loading"
        (click)="cancel.emit()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-dark rounded-3"
        [disabled]="loading || !hasAcceptedTerms"
        (click)="agree.emit()"
      >
        I Agree
        @if (loading) {
          <i class="bx bx-loader-alt bx-spin"></i>
        }
      </button>
    </div>
  </div>
</div>
